export const IS_REQUESTING_LOCALLY = false;

export function buildDashboardUrl(url: string, useLocal: boolean = IS_REQUESTING_LOCALLY): string {
  if (useLocal) {
    return url.replace('/dashboard/api', 'http://localhost:8090/api');
  }
  return url;
}
